<template>
  <div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      :value="openDialog"
      v-model="dialog"
    >
      <v-card>
        <v-card-text class="pa-0 ma-0 ma-sm-0 pa-sm-0">
          <div style="position: absolute;width: 100%;z-index: 1;">
            <v-btn
              fab
              small
              color="grey"
              @click="$emit('update:openDialog', false)"
              max-height="25px"
              max-width="25px"
              class="float-right mt-2 mr-2"
            >
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </div>
          <video
            :src="storyUrl"
            id="video"
            :controls="false"
            autoplay
            @ended="$emit('update:openDialog', false)"
            :style="{ width: 'inherit', height: 'auto' }"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "StoryDialog",
  props: ["openDialog", "storyUrl"],
  data() {
    return {
      dialog: this.openDialog
    };
  },
  watch: {
    dialog(val) {
      this.$emit("update:openDialog", val);
    }
  }
};
</script>
